<template>
  <BootstrapModal
    :dismissible="true"
    :fade="true"
    :centered="true"
    @close-modal="handleCancel"
  >
    <template #header>
      <slot name="header">
        <h5 class="modal-title">
          {{ title }}
        </h5>
      </slot>
    </template>

    <slot>
      <p class="mb-0">
        {{ message }}
      </p>
    </slot>

    <template #footer>
      <slot name="footer">
        <button
          type="button"
          class="btn"
          :class="cancelButtonClass"
          @click="handleCancel"
        >
          {{ cancelText }}
        </button>
        <button
          type="button"
          class="btn"
          :class="confirmButtonClass"
          @click="handleConfirm"
        >
          {{ confirmText }}
        </button>
      </slot>
    </template>
  </BootstrapModal>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import messages from 'locales/ConfirmModal';
import BootstrapModal from 'components/helper/BootstrapModal.vue';

const props = defineProps({
  title: {
    type: String,
    required: false,
    default: null,
  },
  message: {
    type: String,
    required: false,
    default: null,
  },
  confirmText: {
    type: String,
    required: false,
    default: null,
  },
  cancelText: {
    type: String,
    required: false,
    default: null,
  },
  confirmButtonClass: {
    type: String,
    required: false,
    default: 'btn-outline-primary',
  },
  cancelButtonClass: {
    type: String,
    required: false,
    default: 'btn-outline-secondary',
  },
});

const emit = defineEmits(['confirm', 'cancel']);

const { t } = useI18n({ messages });

const title = computed(() => props.title || t('ConfirmModal.title'));
const message = computed(() => props.message || t('ConfirmModal.message'));
const confirmText = computed(() => props.confirmText || t('ConfirmModal.confirm'));
const cancelText = computed(() => props.cancelText || t('ConfirmModal.cancel'));

function handleConfirm() {
  emit('confirm');
}

function handleCancel() {
  emit('cancel');
}
</script>

<style lang="scss" scoped>
</style>
